<div class="out">
  <!-- <k-button class="schedule" background="#8F5DFF" color="white" text="Book a Call" cmd="schedule"></k-button> -->

  <div class="btns">
    <k-button min_width="40" min_height="40" class="btn" background="#ECECEC" icon="settings.svg" kzLib (click)="settings()"></k-button>
    <k-button min_width="40" min_height="40" *ngIf="bAudioOn" background="#ECECEC" class="btn" icon="mic.svg" kzLib (click)="setAudio(false)"></k-button>
    <k-button min_width="40" min_height="40" *ngIf="!bAudioOn" background="#ECECEC" class="btn" icon="mic_off.svg" kzLib (click)="setAudio(true)"></k-button>

    <k-button min_width="40" min_height="40" *ngIf="bShowHangUp" class=" btn" background="#ECECEC" icon="profile_white.svg" kzLib (click)="askEmail()"></k-button>
    <!-- <k-button min_width="40" min_height="40" *ngIf="bShowHangUp && bASskingForEmail" class=" btn" background="#ECECEC" icon="profile.svg"  kzLib (click)="askEmail()"></k-button> -->


    <k-button min_width="40" min_height="40" *ngIf="bVideoOn" class="btn" icon="camera_on.svg" background="#ECECEC" kzLib (click)="setVideo(false)"></k-button>
    <k-button min_width="40" min_height="40" *ngIf="!bVideoOn" class="btn" icon="camera_off.svg" background="#ECECEC" kzLib (click)="setVideo(true)"></k-button>

    <k-button min_width="40" min_height="40" *ngIf="!bShareOn" background="#ECECEC" class=" btn" icon="share.svg" kzLib (click)="share()"></k-button>
    <k-button min_width="40" min_height="40" *ngIf="bShareOn" background="#ECECEC" class=" btn" icon="share_off.svg" kzLib (click)="stopShare()"></k-button>

    <phone-hang-up *ngIf="bShowHangUp" class=" btn" kzLib (click)="hangUp()"></phone-hang-up>
    <status *ngIf="bShowHangUp" class="have_caller_info" [ok]="contactInfo"></status>
  </div>
  <k-button min_width="40" min_height="40" *ngIf="bShowChat" class="chat" background="#151515" icon="arrow_down_white.svg" kzLib (click)="closeChat()"></k-button>
  <k-button min_width="40" min_height="40" *ngIf="!bShowChat" class="chat" background="#151515" icon="chat.svg" internal=true kzLib (click)="openChat()"></k-button>

  <k-button min_width="40" min_height="40" class="white_board" [background]="white_board_btn_back" icon="pencil.svg" kzLib (click)="whiteBoard()"></k-button>


  <div class="kpay" *ngIf="bShowPay" kzLib (click)="kpay()">
    <img src="assets/images/keyzii.svg" class="kpay_l" alt="">
    Pay
  </div>
  <!-- <div class="kpay kpay_c" *ngIf="converge_acc&&bShowHangUp && !bShowDots && ruuning_kpay"  kzLib (click)="close_kpay()">
    Cancel
    <img src="assets/images/kz_sm_wh.svg" class="kpay_cl" alt="">
    <div class="kpay_ctx">
      pay
    </div>
  </div> -->
  <div *ngIf="bShowChatNotification" class="chat-noti">

  </div>
  <div *ngIf="bShowStopSharing" class="stop_sharing" kzLib (click)="close()">
    Stop sharing
    <div class="strop_circle">
      <img class="abs_center" src="assets/images/stop.svg">
    </div>
  </div>
</div>
